import {IExportTemplate} from '../../index';
import {getHash, isRoutePermissionOkay} from '../../constants/RouteDefinitions';
import {nsSynchronizationTemplateClone} from '../../clone/nsSynchronizationTemplateClone';
import {IPageShellHeaderActions} from '../page-shell/pageShellHeaderActions';

/** Sync template actions: export + edit up front; copy and delete behind "Mer". */
export function buildSyncTemplateActions(template: IExportTemplate): IPageShellHeaderActions {
    return {
        quick: [
            {
                icon: 'fa-forward',
                label: 'export attribute|p',
                href: () => getHash('exportflows', {id: template.id}) ?? '',
                validator: () => template.active && isRoutePermissionOkay('exportflows'),
            },
            {
                icon: 'fa-pencil',
                label: 'edit',
                href: () => getHash('editsynctemplate', {id: template.id}) ?? '',
            },
        ],
        more: [
            {
                icon: 'fa-copy',
                label: 'copy',
                onClick: () => nsSynchronizationTemplateClone.copyDialog(template),
                validator: () => isRoutePermissionOkay('createsynctemplate'),
            },
            {
                cls: 'btn-destructive explicit',
                icon: 'fa-trash-alt',
                label: 'delete',
                onClick: () => nsSynchronizationTemplateClone.trashDialog(template),
                enabled: () => isRoutePermissionOkay('createsynctemplate'),
            },
        ],
    };
}
